/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-provider-unit',
  templateUrl: './provider-unit.component.html',
  styleUrls: ['./provider-unit.component.scss'],
})
export class ProviderUnitComponent implements OnInit, OnChanges {
  constructor(
    private router: Router,
    private appService: AppService,
  ) {}

  ngOnInit() {}
  domain = window.location.origin;
  /**卡片数据 */
  @Input() item: any | null = null;

  /**宽高比 */
  @Input() ratio: number = 1 / 0.4;

  @Output() clickItem: EventEmitter<any> = new EventEmitter();

  url: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.url = this.getUrl(changes?.item?.currentValue || null);
  }

  getUrl(item: any | null): string {
    if (!this.item) return '';
    if (item.secondaryPage) {
      return `${this.appService.languageCode}/casino/provider/${item.providerCatId}`;
    } else {
      return `${this.appService.languageCode}/play/${item.providerCatId}`;
    }
  }

  onClickItem() {
    if (!this.item) return;
    const item = this.item;
    this.router.navigateByUrl(this.url);
    this.clickItem.emit(item);
  }
}
